import React from 'react';

/**
 * Phase A.3 — Global footer
 * Layout: left "Developed by Ajinkya Technologies", right small AT badge.
 * Subtle top border, slate text, small font-size. Works for both themes.
 */
export function AppFooter({ isLoginPage = false }) {
  return (
    <footer
      className="h-12 flex items-center justify-between px-6 flex-shrink-0 relative z-10
                 border-t border-slate-200 dark:border-slate-800
                 bg-white dark:bg-slate-950
                 text-slate-500 dark:text-slate-400 text-[12px]"
      data-testid="app-footer"
    >
      <span className="tracking-wide">
        {isLoginPage ? (
          <>
            <a
              href="https://www.ajinkyatechnologies.in"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-slate-700 dark:text-slate-300 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors no-underline"
              data-testid="footer-developer-link"
            >
              Ajinkya Technologies
            </a>
            {', now part of Kadle Global pvt Ltd'}
          </>
        ) : (
          <>
            Developed by{' '}
            <a
              href="https://www.ajinkyatechnologies.in"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-slate-700 dark:text-slate-300 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors no-underline"
              data-testid="footer-developer-link"
            >
              Ajinkya Technologies
            </a>
          </>
        )}
      </span>

      {/* AT initials badge — 32px circle, brand blue, white bold text */}
      <div
        className="w-8 h-8 rounded-full flex items-center justify-center
                   bg-indigo-600 dark:bg-indigo-500
                   text-white text-[11px] font-bold tracking-wider
                   shadow-sm select-none"
        title="Ajinkya Technologies"
        data-testid="footer-at-badge"
      >
        AT
      </div>
    </footer>
  );
}

export default AppFooter;
